import { getTourRateLabel } from './getTourOptions';

const AGE_IN_NAME = /\s*\(([^()]*\d[^()]*)\)\s*$/;

const isAge = (text) => {
  const looksLikeAge =
    /^\d+\s*\+$/.test(text) ||
    /^\d+\s*[-–—]\s*\d+/.test(text) ||
    /^(under|over|up to)\b/i.test(text) ||
    /\b(and over|and under|years?|yrs?)\b/i.test(text);
  return looksLikeAge;
};

const ageInName = (name) => {
  const found = (name || '').match(AGE_IN_NAME);
  const age = found && isAge(found[1].trim()) ? found[1].trim() : null;
  return age;
};

const ageInFields = (rate) => {
  if (rate.minAge != null && rate.maxAge != null) {
    return `${rate.minAge} - ${rate.maxAge}`;
  }
  if (rate.maxAge != null) {
    return `${rate.maxAge} and under`;
  }
  if (rate.minAge != null) {
    return `${rate.minAge} and over`;
  }
  return null;
};

export const getTourRateNameWithoutAge = (rate) => {
  const published = getTourRateLabel(rate);
  const name = ageInName(published) ? published.replace(AGE_IN_NAME, '') : published;
  return name;
};

export const getTourRateAgeLabel = (rate) => {
  const published = getTourRateLabel(rate);
  const label = ageInName(published) || (/\d/.test(published) ? null : ageInFields(rate));
  return label;
};

export const hasCheckableAgeBand = (rate) => {
  const isCheckable = !!rate && (rate.minAge != null || rate.maxAge != null);
  return isCheckable;
};

export const getTourRateAgeError = (rate, age) => {
  if (!hasCheckableAgeBand(rate) || age == null || Number.isNaN(age)) {
    return null;
  }
  if (rate.minAge != null && age < rate.minAge) {
    return `This rate starts at ${rate.minAge}.`;
  }
  if (rate.maxAge != null && age > rate.maxAge) {
    return `This rate is for ages up to ${rate.maxAge}.`;
  }
  return null;
};
